import React from "react";

import { InfoPlate } from "fe-shared/src/components";
import {
  TransferStatusPlate,
  PaperFormIndicator,
  InvalidationStatus,
} from "..";

import { formatTransactionNumber } from "../../helpers/format";
import { Transfer } from "../../types";

import styles from "./TransferStatus.module.scss";

interface Props {
  transfer: Transfer;
}

const TransferStatus = (props: Props) => {
  const {
    statusCode,
    transferNumber,
    isPaperForm,
    isAdjustable,
  } = props.transfer;

  return (
    <div className={styles.header}>
      <div className={styles.status}>
        <InfoPlate variant="black" className={styles.statusInfoPlate}>
          {formatTransactionNumber(transferNumber)}
        </InfoPlate>
        <TransferStatusPlate
          statusCode={statusCode}
          className={styles.statusInfoPlate}
          isAdjustable={isAdjustable}
        />
        <PaperFormIndicator isPaperForm={isPaperForm} />
      </div>
      <InvalidationStatus transactionOrTransfer={props.transfer} />
    </div>
  );
};

export default TransferStatus;
